import Link from "next/link";
import { usePathname } from "next/navigation";
import { format } from "date-fns";
import { OctagonPause } from "lucide-react";

import { Button } from "@acme/ui/button";

export function RateLimitMessage({ reset }: { reset: Date }) {
  const formattedTime = format(reset, "hh:mm a");

  const formattedDate = format(reset, "MMM d");

  const pathname = usePathname();

  return (
    <div className="flex h-full flex-col items-center justify-center p-8 text-center">
      <div className="mb-4 text-yellow-500">
        <OctagonPause className="size-10" />
      </div>
      <h3 className="mb-2 text-lg font-medium">Rate limit reached</h3>
      <p className="text-muted-foreground mb-4 text-xs">
        You've reached the free usage limit. Check back at {formattedTime} on{" "}
        {formattedDate}, or sign in to use the AI now.
      </p>
      <Button asChild>
        <Link href={`/login?redirect=${pathname}`}>Sign In</Link>
      </Button>
    </div>
  );
}
